import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { supplierCompanyProfileService } from "~/services/purchasing/supplierCompanyProfileService";

import type { SupplierCompanyProfileFormData } from "~/types/purchasing";

export const SUPPLIER_COMPANY_PROFILES_KEY = ["supplierCompanyProfiles"];

export function useSupplierCompanyProfiles(supplierId?: string) {
  return useQuery({
    queryKey: [...SUPPLIER_COMPANY_PROFILES_KEY, supplierId],
    queryFn: () => supplierCompanyProfileService.listBySupplier(supplierId!),
    enabled: !!supplierId,
  });
}

export function useCreateSupplierCompanyProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SupplierCompanyProfileFormData) =>
      supplierCompanyProfileService.create(data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: SUPPLIER_COMPANY_PROFILES_KEY,
      }),
  });
}

export function useUpdateSupplierCompanyProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: Partial<SupplierCompanyProfileFormData>;
    }) => supplierCompanyProfileService.update(id, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: SUPPLIER_COMPANY_PROFILES_KEY,
      }),
  });
}

export function useDeleteSupplierCompanyProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => supplierCompanyProfileService.delete(id),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: SUPPLIER_COMPANY_PROFILES_KEY,
      }),
  });
}
